import * as React from 'react';
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { find } from "lodash";
import Alert, { AlertCategoryEnum } from "../../../misc/components/Alert";
import { useSecurityContext } from '../../../Core/SecurityContext';

export const FilteredNotesNotificationBanner = (): JSX.Element => {

    const { currentUserPermissions } = useSecurityContext();

    var allNotesPermissionExists = find(currentUserPermissions, cp => cp.Id === PermissionEnum.ViewAllCoughSessionNotes);

    return (<Alert show={!allNotesPermissionExists} category={AlertCategoryEnum.Info} > The visible notes are filtered as you do not have permission to view all notes for this cough session.
            </Alert>);
};
